import Axios from 'axios'
let axios = Axios.create()
let axiosRaw = Axios.create()

axios.interceptors.response.use((response)=>{
    // Si existe un problema de red, terminar la promesa
    if( response instanceof Error ){
        return Promise.reject(response.message)
    }else{
        return Promise.resolve(response.data)
    }
})
axiosRaw.interceptors.response.use((response)=>{
    // Si existe un problema de red, terminar la promesa
    if( response instanceof Error ){
        return Promise.reject(response)
    }else{
        return Promise.resolve(response)
    }
})

export default {
    admin: {
        calendar: {
            getDays: (month, statusDays) => 
                axios.get(`/api/calendar/search-days?month=${month}&statusDays=${statusDays}`),
            updateStatusDay: (day, statusDay) =>
                axios.put(`/api/calendar/day/${day}/update-status`, {statusDay}),
            updateCommentDay: (day, comment) => 
                axios.put(`/api/calendar/day/${day}/update-comment`, {comment})
        }
    },
    client: (idClient) => ({
        getEmailsBilling: () =>
            axios.get(`/api/client/${idClient}/email-billing`),
        addEmailBilling: (dataEmail) =>
            axios.post(`/api/client/${idClient}/email-billing`, dataEmail),
        deleteEmailBilling: (idEmail) =>
            axios.delete(`/api/email-billing/${idEmail}`)
    }),
    billing: () => ({
        getServicesByMonthAndClient: (idClient, month) =>
            axios.get(`/api/billing/services-fsb?id_client=${idClient}&month=${month}&billable=true&calculate_totals=true&order=desc`),
        getServicesBillingFsb: (idBillingRequest) =>
            axios.get(`/api/billing/services-fsb?id_billing_request=${idBillingRequest}&calculate_totals=true`),
        getServices: (idClient, initDate, finishDate) =>
            axios.get(`/api/billing/services?id_client=${idClient}&init_date=${initDate}&finish_date=${finishDate}`),
        setStatusPaymentService: (idService, statusClient) =>
            axios.post(`/api/billing/service/${idService}/status-client`, {statusClient}),
        setStatusPaymentAllService: (idBillingRequest, statusClient) =>
            axios.post(`/api/billing/services/status-client-all`, {idBillingRequest, statusClient}),
        getBillingRequest: (idBillingRequest) =>
            axios.get(`/api/billing/billing-request?idBillingRequest=${idBillingRequest}`),
        dischargeServices: (idBillingRequest) => 
            axios.post(`/api/billing-request/${idBillingRequest}/discharge-services`),
        dischargeOC : (idBillingRequest) =>
            axios.post(`/api/billing-request/${idBillingRequest}/discharge-oc`),
        assignOC : (idBillingRequest, data) => 
            axios.post(`/api/billing-request/${idBillingRequest}/assign-oc`, data),
        rejectRequest: (idBillingRequest, msg) =>
            axios.post(`/api/billing-request/${idBillingRequest}/reject-oc`, {msg})
    }),
    lists: () => ({
        finishReviewLists: (initDate, finishDate, withEmail) => 
            axios.post(`/api/lists/approve-review`, {initDate, finishDate, withEmail})
    })
}


// WEBPACK FOOTER //
// ./frontEnd/apiClient/v2.js